import {
  GET_UTILITY_REQUEST_CARD_STATES,
  GET_UTILITY_REQUEST_CARD_STATES_SUCCESS,
  GET_UTILITY_REQUEST_CARD_STATES_ERROR,
  GET_UTILITY_REQUEST_CARD_STATES_EMPTY,
} from '../../actions.js';

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const GetUtilityRequestCardStates = (state = initialState, action) => {
  switch (action.type) {
    case GET_UTILITY_REQUEST_CARD_STATES:
      return { ...state, loading: true };

    case GET_UTILITY_REQUEST_CARD_STATES_SUCCESS:
      return { ...state, loading: false, data: action.payload };

    case GET_UTILITY_REQUEST_CARD_STATES_ERROR:
      return { ...state, loading: false, error: action.payload };

    case GET_UTILITY_REQUEST_CARD_STATES_EMPTY:
      return { ...initialState };

    default:
      return state;
  }
};

export default GetUtilityRequestCardStates;
